import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../components/AuthProvider';
import '../styles/UserForgotPasswordPage.css';
import UserForgotPasswordForm from '../forms/UserForgotPasswordForm';
import { requestUserPasswordReset } from '../services/UserAuthService';
import bannerImage from '../../images/Logo/Company_Logo_Black.png';


const UserForgotPasswordPage = () => {
  const { userData, getCookie } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showEmailField, setShowEmailField] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (userData && !userData.is_admin) {
      navigate('/admin');
    }
  }, [userData, navigate]);

  const MAX_EMAIL_LENGTH = 320;

  const handleEmailChange = (e) => setEmail(e.target.value);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateForm = () => {
    if (!email) {
      return 'Please enter your email address.';
    }

    if (email.length > MAX_EMAIL_LENGTH) {
      return `Email cannot exceed ${MAX_EMAIL_LENGTH} characters.`;
    }

    if (!validateEmail(email)) {
      return 'Please enter a valid email address.';
    }

    return '';
  };

  const handleSubmit = async () => {
    setFormSubmitted(true);
    const validationError = validateForm();

    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const csrftoken = getCookie('csrftoken');
      const result = await requestUserPasswordReset(email, csrftoken);
      if (result.success) {
        setSuccessMessage(result.message);
        setEmail('');
        setShowEmailField(false);
      } else {
        setErrorMessage(result.message);
      }
    } catch (error) {
      setErrorMessage('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="auth-page__structure">
        <div className="auth-page__content">
          <div className="auth-page__right">
            <div className="forgot-password-page__card">
              <div className="forgot-password-page__intro">
                <h2>I Forgot My Password</h2>
                <p>Enter your email address to reset your password.</p>
              </div>
              <UserForgotPasswordForm
                email={email}
                errorMessage={errorMessage}
                successMessage={successMessage}
                loading={loading}
                formSubmitted={formSubmitted}
                handleEmailChange={handleEmailChange}
                showEmailField={showEmailField}
              />
              <div className="forgot-password-page__buttons">
                <button
                  className="button"
                  onClick={handleSubmit}
                  disabled={loading || !email || !!successMessage}
                >
                  {loading ? 'Sending...' : 'Send'}
                </button>
              </div>
              <div className="forgot-password-page__footer">
                <p>Remember your password? <a href="/login">Click here</a> to login.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserForgotPasswordPage;